import { createSlice } from '@reduxjs/toolkit';
import { USER_FILTER_VALUES } from 'helpers/constants';

const initialState = {
    settings: {},
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        toggleSettings(state, action) {
            if (action.payload.settings) {
                state.settings = action.payload.settings;
            }
        },
    }
});

export const settingsActions = settingsSlice.actions;
export default settingsSlice.reducer;
